import PromoCode from './PromoCode';

export default PromoCode;